/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Weiterebeteiligtepersonenids4Inputs */

const de__field_weiterebeteiligtepersonenids4 = /** @type {(inputs: _Field_Weiterebeteiligtepersonenids4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere beteiligte PersonenIDs`)
};

/**

* @param {_Field_Weiterebeteiligtepersonenids4Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_weiterebeteiligtepersonenids4 = /** @type {((inputs?: _Field_Weiterebeteiligtepersonenids4Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Weiterebeteiligtepersonenids4Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_weiterebeteiligtepersonenids4(inputs)
});
export { _field_weiterebeteiligtepersonenids4 as "_field_weitereBeteiligtePersonenIDs" }